import { call, put, select, takeLatest } from 'redux-saga/effects';

import API from 'services/api';

import { getGroupId } from 'store/session/selectors';

import {
  conformanceLanguageUpdate,
  conformanceLanguageFetch,
  types,
} from './actions';

export default function* root() {
  yield takeLatest(
    types.CONFORMANCE_LANGUAGE_UPDATE_REQUEST,
    watchConformanceLanguageUpdate,
  );
}

function* watchConformanceLanguageFetch() {
  try {
    const groupId = yield select(getGroupId);
    const { value } = yield call(API.supplier.getConformanceLanguage, groupId);
    yield put(conformanceLanguageFetch.success({ conformanceLanguage: value }));
  } catch (error) {
    console.error('FAILED TO FETCH CONFORMANCE LANGUAGE', error);
  }
}

function* watchConformanceLanguageUpdate(action) {
  try {
    const groupId = yield select(getGroupId);
    const { conformanceLanguage } = action.payload;
    const { value } = yield call(
      API.supplier.updateConformanceLanguage,
      groupId,
      {
        value: conformanceLanguage,
      },
    );
    if (value) {
      yield put(
        conformanceLanguageUpdate.success({ conformanceLanguage: value }),
      );
    }
  } catch (error) {
    yield put(conformanceLanguageUpdate.error(error));
  }
}

export function* initSaga() {
  yield call(watchConformanceLanguageFetch);
}
